import { Injectable } from '@angular/core';
import { fromEvent, interval, Observable, Subject } from 'rxjs';
import { ConectionEnum, ConectionStatusDto } from '../../model/conectionStatus.dto';
import { DateServerService } from '../dateServerService/date-server.service';
import { catchError, map, startWith, switchMap, takeUntil } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class NetworkConectionService {

  private networkStatuses: ConectionStatusDto[] = [];

  onlineEvent: Observable<Event>;
  offlineEvent: Observable<Event>;

  constructor(private http: HttpClient) {
    this.onlineEvent = fromEvent(window, 'online');
    this.offlineEvent = fromEvent(window, 'offline');
  }

  createNewStatus(credencial: number, estado: ConectionEnum, 
     _dateServerService: DateServerService): ConectionStatusDto {
    const status = new ConectionStatusDto();
    status.credencialUsuario = credencial;
    status.estado = estado
    status.fechaSuceso =  _dateServerService.getDateServer();
    return status;
  }

  setNewStatus(conectionStatusDto: ConectionStatusDto): void {
    this.networkStatuses.push(conectionStatusDto);
  }

  getNetworkStatuses(): ConectionStatusDto[] {
    return this.networkStatuses;
  }

  resetNetworkStatuses () : void {
    this.networkStatuses = [];
  }

  private readonly checkInterval = 2000; // Intervalo de comprobación en milisegundos
  private readonly url = 'https://httpbin.org/status/200'; // Utiliza una URL confiable

  private stopPolling = new Subject<void>(); // Sujeto de finalización


  checkInternetConnection(): Observable<boolean> {
    return interval(this.checkInterval).pipe(
      startWith(0), // Emitir inmediatamente al suscribirse
      switchMap(() => {
        return this.http.head(this.url).pipe(

          map(() => {
            console.log("Hay Internet");
            return true}), // Éxito significa que hay conexión
          catchError(() => {
            console.log("NO hay Internet");
            return [false]; // Error significa que no hay conexión
          })
        );
      }),
      takeUntil(this.stopPolling) // Detener el intervalo cuando el sujeto emite
    );
  }

  stopConnectionCheck() {
    this.stopPolling.next(); // Emitir un valor en el sujeto para detener el intervalo
  }
}